/* eslint-disable prefer-rest-params */
import analytics from '../modules/analytics';

export default function initGA() {
  analytics.init();
}
